import { CommonModule } from "@angular/common";
import { Component, computed, input, output, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BookOpenIcon, ExternalLinkIcon, LucideAngularModule, Fullscreen  } from "lucide-angular";
import { OriBadgeComponent } from "~/components/ui/badge";
import { OriButton } from "~/components/ui/button";

@Component({
  standalone: true,
  imports: [
    LucideAngularModule,
    OriButton,
    OriBadgeComponent,
    FormsModule,
    CommonModule

  ],
  template: `
    <div class="flex flex-col gap-1">
      <div class="flex flex-row items-center justify-items-center h-[30px] " (mouseenter)="handleMouseEnter()" (mouseleave)="handleMouseLeave()">
          <span (click)="onClick()" data-prevent-row-click class="font-semibold"
            [ngClass]="{
              'text-blue-500 underline cursor-pointer': isOpen,
              'text-gray-500': !isOpen
            }"
          >{{value()}}</span>
          @if (isOpen) {
            <div (click)="onClick()" data-prevent-row-click class="ml-auto p-[2px] cursor-pointer select-none h-[30px] transition-all duration-300 ease-in-out"
                [ngClass]="{
                  'bg-white border border-gray-200 outline-1 shadow-sm rounded-lg opacity-100 scale-100': isOpen,
                  'opacity-0 scale-95 pointer-events-none': !isOpen
                }">
              <div class="flex flex-row gap-1 p-1 text-gray-500 items-center justify-items-center font-semibold rounded-md border-none hover:bg-gray-100">
                <lucide-angular [img]="Fullscreen" size="16" class=""/>
                <span class="text-xs">OPEN</span>
              </div>
            </div>
          } 
      </div>
        <div class="flex flex-row flex-wrap gap-1">
        @for (product of productsList(); track product) {
               <ori-badge variant="outline" class="rounded-sm text-xs bg-blue-100">{{product}}</ori-badge>
        }

          </div>
    </div>
  `,


    
})
export class LinkCellComponent {
  readonly value = input<unknown>();
  readonly click = output<unknown>();
  readonly products = input<unknown>();

  readonly productsList = computed(() => {
    const data = this.products();
    if (data && typeof data === 'object' && 'products' in data) {
      return (data as any).products as string[];
    }
    return [];
  });

  //   readonly LinkIcon = LinkIcon;
  readonly ExternalLink = ExternalLinkIcon;
  readonly BookOpen = BookOpenIcon;
  readonly Fullscreen = Fullscreen;
  isOpen = false;

  handleMouseEnter() {
    this.isOpen = true;
  }

  handleMouseLeave() {
    this.isOpen = false;
  }

  onClick() {
    this.click.emit(this.value());
  }
}